import Request from './request'

const MnoApi = {
  getOperatorsAPI(callback) {
    Request.get('mno-api/list').then(callback).catch(this.bad_answer)
  },
}
export default MnoApi
